/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CreateCharge_service = {
    readonly id: string;
    readonly supportedCurrencies: ReadonlyArray<string>;
    readonly supportableCurrencies: ReadonlyArray<string>;
    readonly " $refType": "CreateCharge_service";
};
export type CreateCharge_service$data = CreateCharge_service;
export type CreateCharge_service$key = {
    readonly " $data"?: CreateCharge_service$data;
    readonly " $fragmentRefs": FragmentRefs<"CreateCharge_service">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateCharge_service",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportedCurrencies",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportableCurrencies",
      "storageKey": null
    }
  ],
  "type": "Service",
  "abstractKey": null
};
(node as any).hash = 'e6b3675d0cf375844bf64c4d22ba27a0';
export default node;
